import { Component, OnInit } from '@angular/core';
import { Auth } from 'src/common/security';
import { TranslationManager } from 'src/common/translation';
import { MessagesComponent } from 'src/common/components';
import { Router } from '@angular/router';


@Component({
    selector: 'logout',
    templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {

    translationManager = TranslationManager;
    auth = Auth;
    error: string;

    constructor(private router: Router) { }

    ngOnInit(): void {
        this.logout();
    }

    logout() {
        if(Auth.isAuthenticated){
            MessagesComponent.instance.showWarning([this.translationManager.getTranslation('Због дуже неактивности, аутоматски сте излоговани из система.')]);
            Auth.logOut().then(() => {
                //this.router.navigate(['/unauthorized']);
                this.router.navigate(['/']);

            }).catch((e: any) => {
                this.error = e.error.messages;
                MessagesComponent.instance.showError([this.error]);
            });
        }else{
            this.router.navigate(['/']);
        }
    }

    
}
